import { setAriaProp, trapFocus, emitter } from "@common/utilities.js";
export default class HeaderSmall {
	constructor(config) {
		this.el = config.el || document.querySelector(".header--small");
		this.timeout = null;
		this.menuClose = this.el.querySelector(".header__close");
		this.menuOpen = this.el.querySelector(".header__burger");
		this.menuOpenClass = "header--show-panel";

		this.menuPanelClass = ".header__small-panel";
		this.menuPanel = this.el.querySelector(this.menuPanelClass);

		this.headerLinks = this.el.querySelector(".header__link");
		this.HeaderSubpanelButtons =
			this.el.querySelectorAll(".header__page-nav");
		this.collapsedHeaderSubpanelClass = ".header__page-nav--collapsed";
		this.expandedHeaderSubpanelClass = ".header__page-nav--expanded";
		this.pageBackgroundClass = "header__page--background";
		this.navBackgroundClass = "header__page-nav--background";

		this.menuSubpanelClass = ".header__page--sub-nav";
		this.menuSubpanel = this.el.querySelectorAll(this.menuSubpanelClass);
		this.panelVisible = false;
		this.init();
	}
	init() {
		this.attachEvents();
	}
	attachEvents() {
		const self = this;
		this.menuOpen.addEventListener("click", function () {
			//show panel
			self.showPanel();
		});
		this.menuClose.addEventListener("click", function () {
			self.hidePanel();
		});

		this.HeaderSubpanelButtons.forEach((el) => {
			el.addEventListener("click", () => {
				if (el.classList.contains("expanded")) {
					//hide sub-nav
					self.hideSubPanel(
						el.querySelector(self.expandedHeaderSubpanelClass)
					);
				} else {
					//show sub-nav
					self.showSubPanel(
						el.querySelector(self.collapsedHeaderSubpanelClass)
					);
				}
			});
		});
		this.menuPanel.addEventListener("keydown", (e) => {
			if (e.code === "Escape" && this.panelVisible) {
				this.hidePanel();
			}
		});

		emitter.on("window/scroll", function (obj) {
			if (self.timeout) {
				clearTimeout(this.timeout);
			}
			self.timeout = setTimeout(() => {
				if (obj.direction == "up") {
					self.el.classList.remove("header--hide");
				} else if (obj.direction == "down") {
					if (obj.top > 50) {
						self.el.classList.add("header--hide");
					}
				}
			}, 50);
		});

		trapFocus(this.menuPanel);
	}
	showPanel() {
		this.panelVisible = true;
		document.documentElement.classList.add("mobile-nav-open");
		setAriaProp(this.menuClose, "hidden", false);
		setAriaProp(this.menuOpen, "hidden", true);

		setAriaProp(this.menuPanel, "hidden", false);
		this.menuPanel.style.visibility = "visible";
		this.el.classList.add(this.menuOpenClass);
	}
	hidePanel() {
		this.panelVisible = false;
		document.documentElement.classList.remove("mobile-nav-open");
		setAriaProp(this.menuClose, "hidden", true);
		setAriaProp(this.menuOpen, "hidden", false);

		setAriaProp(this.menuPanel, "hidden", true);
		this.menuPanel.style.visibility = "hidden";
		this.el.classList.remove(this.menuOpenClass);
	}
	showSubPanel(el) {
		const subnav = el.parentElement.parentElement.parentElement;

		el.parentElement.parentElement.classList.remove(
			this.pageBackgroundClass,
			this.navBackgroundClass
		);

		subnav.querySelector(this.menuSubpanelClass).style.cssText =
			"display: flex; visibility: visible";

		subnav.querySelector(".header__page-nav").classList.add("expanded");
		subnav
			.querySelector(this.collapsedHeaderSubpanelClass)
			.classList.add("hidden");
		subnav
			.querySelector(this.expandedHeaderSubpanelClass)
			.classList.remove("hidden");
	}
	hideSubPanel(el) {
		const subnav = el.parentElement.parentElement.parentElement;
		el.parentElement.parentElement.classList.add(
			this.pageBackgroundClass,
			this.navBackgroundClass
		);

		subnav.querySelector(this.menuSubpanelClass).style.cssText =
			"display: none; visibility: hidden";
		subnav.querySelector(".header__page-nav").classList.remove("expanded");

		subnav
			.querySelector(this.collapsedHeaderSubpanelClass)
			.classList.remove("hidden");
		subnav
			.querySelector(this.expandedHeaderSubpanelClass)
			.classList.add("hidden");
	}
}
